module.exports = __webpack_public_path__ + "static/img/markus-frieauff-IJ0KiXl4uys-unsplash_thumb.0a888da.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/markus-frieauff-IJ0KiXl4uys-unsplash_thumb.png
// module id = R4kU
// module chunks = 4